export const types = {
    SET_GET_OPERATORS: '[OPERATORS] SET GET OPERATORS',
    SET_GET_OPERATORS_BY_ID: '[ROLE] SET GET OPERATORS BY ID'
}